export default class ProjectCalculation {
    constructor() {
        this.id = null
        this.name = ''
        this.opportunity_id = null

        this.working_days = 7.6
        this.hourly_rate_cents = 26600
        this.warranty_percentage = 0.1

        this.dev_days = 8.5
        this.num_devs = 1
        this.sprint_rituals_estimate = 3
        this.scoping_sprint_testing = 2
        this.project_management = 1
        this.base_effort_estimation = null
        this.evaluation = 5
        this.contingency_days = 3
        this.efficiency = 0.8
    }
}
